import { useEffect, useState } from 'react';
import styles from './Tooltip.module.css';
import info from 'images/info.svg';
import { convertDownloadHistoryData } from 'utils/DataUtils';

const Tooltip = ({ content }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [historyData, setHistoryData] = useState();

  const handleMouseEnter = () => {
    setShowTooltip(true);
  }

  const handleMouseLeave = () => {
    setShowTooltip(false);
  }

  useEffect(() => {
    const data = convertDownloadHistoryData(content);
    setHistoryData(data);
  }, [content]);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={styles['container']}
    >
      <img src={info} alt='info' />
      {showTooltip && (
        <div className={styles['tooltip']}>
          <p className={styles['title']}>검색기록</p>
          <p className={styles['sub-desc']}>최대 3개의 내역만 기록됩니다.</p>
          {historyData ? historyData.map((item, index) => {
           return (
            <div className={styles['contents-wrap']} key={index}>
              <div className={styles['contents']}>
                <p className={styles['key']}>작업ID</p>
                <p className={styles['value']}>{item.job_id}</p>
              </div>
              <div className={styles['contents']}>
                <p className={styles['key']}>검색일자</p>
                <p className={styles['value']}>{item.dateRange[0]} ~ {item.dateRange[1]}</p>
              </div>
              <div className={styles['contents']}>
                <p className={styles['key']}>다운로드일자</p>
                <p className={styles['value']}>{item.download_at}</p>
              </div>
              <div className={styles['contents']}>
                <p className={styles['key']}>진행상태</p>
                <p className={styles['value']}>{item.status}</p>
              </div>
            </div>
           ) 
          }) : <p className={styles['nodata']}>다운로드내역이 없습니다.</p>}
        </div>
      )}
    </div>
  )
}

export default Tooltip;